import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-invitation-needed',
  templateUrl: './invitation-needed.component.html',
  styleUrls: ['./invitation-needed.component.css'],
})
export class InvitationNeededComponent {
  betaRequestUrl: string = environment.betaRequestUrl || '';

  get hasRequestUrl(): boolean {
    return !!this.betaRequestUrl?.trim();
  }
}
